import { setOrderDeliveryZoneData, setSelectedCity } from '../../../actions';
import { identityPayload, createReducer, forAction } from '../../../utils';

const initialState = null;

export default createReducer(
  [
    forAction(setOrderDeliveryZoneData, identityPayload),
  ],
  initialState,
  [setSelectedCity],
);
